


























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ISearchResult, SearchType } from '../Scripts/ISearchService';
import { FilterHelper } from '../Scripts/FilterHelper';

import ResultsPanel from './ResultsPanel.vue';
import SortParameters from './SortParameters.vue';
import FacetPanel from './FacetPanel.vue';
import PagePanel from './PagePanel.vue';
import SearchSummary from './SearchSummary.vue';
import CurrentFilters from './CurrentFilters.vue';

import { Route } from 'vue-router';
import { mapGetters } from 'vuex';
import { Getters } from '../store';
import { msiInfo } from '../Scripts/MsiInfo';

import AppConfig from '../Scripts/AppConfig';
import { AxiosError } from 'axios';

@Component({
	components: {
		ResultsPanel,
		SortParameters,
		FacetPanel,
		PagePanel,
		SearchSummary,
		CurrentFilters
	},
	computed: {
		...mapGetters({
			applicationName: Getters.applicationName
		})
	}
})
export default class QueryPanel extends Vue {
	errorMsg = '';

	@Watch('$route')
	public async onRouteChange (route: Route): Promise<void> {
		await this.performSearch(route);
	}

	@Watch('loading')
	public onLoadingChange (val: boolean): void {
		if (val) {
			const body = document.getElementsByTagName('body')[0];
			this.$scrollTo(body, 500);
		}
	}

	public async mounted (): Promise<void> {
		await msiInfo.populate();
		await this.performSearch(this.$route);
	}

	async performSearch (route: Route): Promise<void> {
		try {
			this.errorMsg = '';
			this.$store.dispatch('initFromRoute', route);
			await this.$store.dispatch('performSearch');
		} catch (err) {
			// long term we should push this determination back to the AzureSearchService
			const resp = err as AxiosError;

			if (resp && resp.response && resp.response.data && resp.response.data.error && resp.response.data.error.code === 'InvalidRequestParameter') { this.errorMsg = 'Clearing or simplifiying your search keywords may help.'; } else { this.errorMsg = 'The search service may not be available at this time.'; }
		}
	}

	get loading (): boolean {
		return this.$store.state.loading;
	}

	get count (): number {
		return this.results ? this.results.count : 0;
	}

	get results (): ISearchResult {
		return this.$store.state.result as ISearchResult;
	}

	get queryNoMatches (): boolean {
		return this.$store.state.queryNoMatch;
	}

	get submittedQuery (): string {
		return this.$store.state.submittedQuery;
	}

	get query (): string {
		return this.$store.state.query;
	}

	set query (value: string) {
		this.$store.commit('changeQuery', value);
	}

	public clearKeywords (): void {
		this.query = '';
	}

	public async search (): Promise<void> {
		const helper = new FilterHelper(this.$router);

		const keywords = (this.query || '').trim();

		if (keywords) {
			helper.setKeywords(keywords);
		} else {
			helper.clearKeywords();
		}
	}

	get selectedSearch (): string {
		return `${SearchType[this.$store.state.searchType]}s`;
	}

	switchType (option: string): void {
		const helper = new FilterHelper(this.$router);

		helper.setSearch(option);
	}

	get programVariant (): string {
		switch (this.$store.state.searchType) {
			case SearchType.Program: return 'primary';
			case SearchType.Course: return 'outline-primary';
			default: return 'primary';
		}
	}

	get courseVariant (): string {
		switch (this.$store.state.searchType) {
			case SearchType.Program: return 'outline-primary';
			case SearchType.Course: return 'primary';
			default: return 'primary';
		}
	}

	get courseSearchEnabled (): boolean {
		return AppConfig.courseSearchEnabled;
	}
}
